module.exports = __webpack_public_path__ + "img/1F912.0f3e69c5.svg";